import { FloatingPortal } from '@floating-ui/react';
import { AnimatePresence, motion } from 'motion/react';

import { useToastStore } from '../../lib/toast.store';
import { Toast } from '../Toast';
import { useStyles } from './ToastContainer.styles';

export const ToastContainer = () => {
  const classes = useStyles();
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  return (
    <FloatingPortal>
      <div css={classes.container}>
        <AnimatePresence mode="popLayout">
          {toasts.map((toast) => (
            <motion.div key={toast.id} css={classes.toastWrapper} layout="position">
              <Toast toast={toast} onDismiss={removeToast} />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </FloatingPortal>
  );
};
